import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dialogs-component",
    {
      ref: "dialog",
      attrs: { width: 560, custom_title: true, "show-buttons": false },
      on: { onCloseClick: _vm.onDismiss },
    },
    [
      _c("template", { slot: "title" }, [
        _c("div", { staticClass: "hub-ia-header" }, [
          _c(
            "div",
            { staticClass: "hub-ia-header__icon" },
            [
              _c(VIcon, { attrs: { color: "primary" } }, [
                _vm._v("mdi-robot-outline"),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "hub-ia-header__text" }, [
            _c("div", { staticClass: "hub-ia-header__title" }, [
              _vm._v(_vm._s(_vm.$t("chatbots.hub_ia_migration.title"))),
            ]),
            _c("div", { staticClass: "hub-ia-header__subtitle" }, [
              _vm._v(_vm._s(_vm.$t("chatbots.hub_ia_migration.subtitle"))),
            ]),
          ]),
        ]),
      ]),
      _c(
        "template",
        { slot: "body" },
        [
          _c("p", { staticClass: "hub-ia-intro" }, [
            _vm._v(_vm._s(_vm.$t("chatbots.hub_ia_migration.description"))),
          ]),
          _c(
            VCard,
            {
              staticClass: "hub-ia-option hub-ia-option--v2",
              attrs: { outlined: "" },
              on: { click: _vm.onSelectV2 },
            },
            [
              _c("div", { staticClass: "hub-ia-option__head" }, [
                _c("span", { staticClass: "hub-ia-option__name" }, [
                  _vm._v(_vm._s(_vm.$t("chatbots.hub_ia_migration.v2_name"))),
                ]),
                _c("span", { staticClass: "hub-ia-badge hub-ia-badge--new" }, [
                  _vm._v(_vm._s(_vm.$t("chatbots.hub_ia_migration.v2_badge"))),
                ]),
              ]),
              _c(
                "ul",
                { staticClass: "hub-ia-features" },
                _vm._l(_vm.v2Features, function (feature, index) {
                  return _c(
                    "li",
                    { key: index, staticClass: "hub-ia-features__item" },
                    [
                      _c(
                        VIcon,
                        {
                          staticClass: "hub-ia-features__check",
                          attrs: { small: "" },
                        },
                        [_vm._v("mdi-check")]
                      ),
                      _c("span", [_vm._v(_vm._s(feature))]),
                    ],
                    1
                  )
                }),
                0
              ),
            ]
          ),
          _c(
            VCard,
            {
              staticClass: "hub-ia-option hub-ia-option--v1",
              attrs: { outlined: "" },
              on: { click: _vm.onSelectV1 },
            },
            [
              _c("div", { staticClass: "hub-ia-option__head" }, [
                _c("span", { staticClass: "hub-ia-option__name" }, [
                  _vm._v(_vm._s(_vm.$t("chatbots.hub_ia_migration.v1_name"))),
                ]),
                _c(
                  "span",
                  { staticClass: "hub-ia-badge hub-ia-badge--current" },
                  [_vm._v(_vm._s(_vm.$t("chatbots.hub_ia_migration.v1_badge")))]
                ),
              ]),
              _c("p", { staticClass: "hub-ia-option__text" }, [
                _vm._v(
                  _vm._s(_vm.$t("chatbots.hub_ia_migration.v1_description"))
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }